import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { Grid2, Button, IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

class CancelButton extends Component {

    constructor(props) {
        super(props);
        this.state = { status: false, cancel_font: '', cancel_btn: '', }
    }

    componentDidMount = () => {
        let is_current_user_voted = this.props.singlepost.is_current_user_voted?.length ? true : false;
        this.setState({ status: is_current_user_voted });
        this.setState({
            cancel_font: this.props.settings.color.cancel_button_color,
            cancel_btn: this.props.settings.color.cancel_button_bgcolor,
        });
    }

    componentWillReceiveProps = (nextProps) => {
        if (typeof nextProps.update_vote_count !== "undefined") {
            let is_current_user_voted = false;

            let voting_freq = (typeof nextProps.update_vote_count.cat_select !== "undefined") ? nextProps.update_vote_count.cat_select : "";
            let response_val = (typeof nextProps.update_vote_count.resp_val !== "undefined") ? nextProps.update_vote_count.resp_val : "";
            let post_id_val = (typeof nextProps.singlepost !== "undefined") ? nextProps.singlepost.id : "";
            let post_index = nextProps.update_vote_count.post_index;
            let single_index = nextProps.indexpost;

            is_current_user_voted = (typeof nextProps.singlepost?.is_current_user_voted !== "undefined") ? nextProps.singlepost?.is_current_user_voted : false;
            if (is_current_user_voted == false) {
                is_current_user_voted = (typeof nextProps.update_vote_count?.is_votable?.update_vote_count !== "undefined") ? nextProps.update_vote_count.is_votable.update_vote_count?.is_current_user_voted : false;
            }

            if (is_current_user_voted == false) {
                is_current_user_voted = (typeof nextProps.update_vote_count?.voted_post_ids !== "undefined") ? nextProps.update_vote_count.voted_post_ids : [];
            }

            let check_post_id_exists = is_current_user_voted !== undefined && is_current_user_voted != 0 ? this.isContains(is_current_user_voted, "post_id", post_id_val) : false;
            let is_cancel_vote = (typeof nextProps.is_cancel_vote !== "undefined") ? nextProps.is_cancel_vote : false;
            let user_vote_count = (typeof nextProps.update_vote_count !== "undefined") ? nextProps.update_vote_count?.user_count : 0;

            if (voting_freq == 'no_limit') {
                if (response_val == 'single') {
                    if (post_index == single_index && user_vote_count > 0) {
                        this.setState({ status: true });
                    }
                    else {
                        this.setState({ status: false });
                    }
                }
                else {
                    this.setState({ status: check_post_id_exists });
                }
            }
            if (voting_freq == 'per_calendar' || voting_freq == 'per_hour' || voting_freq == 'per_category') {
                if (response_val == 'single') {
                    let butn_mesg = nextProps.vote_btn_msg;
                    if (post_index == single_index && user_vote_count > 0 && (butn_mesg == "voteagain" || butn_mesg == "voted")) {
                        this.setState({ status: true });
                    }
                    else {
                        this.setState({ status: false });
                    }
                }
                else {
                    let butn_mesg = nextProps.vote_btn_msg;
                    let voted_post_ids = (typeof nextProps.update_vote_count?.voted_post_ids !== "undefined") ? nextProps.update_vote_count.voted_post_ids : [];
                    check_post_id_exists = voted_post_ids !== undefined && voted_post_ids != 0 ? this.isContains(voted_post_ids, "post_id", post_id_val) : false;
                    if (butn_mesg == "voted" || butn_mesg == "voteagain") {
                        this.setState({ status: true });
                    }
                    else {
                        this.setState({ status: false });
                    }
                }
            }
            //this.setState({ status : check_post_id_exists});
        }
    }


    isContains(json, key, value) {
        let contains = false;
        json.filter(function (object) {
            if ((object[key] == value)) {
                contains = true;
            }
        });
        return contains;
    }

    toggleHovertwo = (value, val) => () => {
        this.setState({ cancel_font: value, cancel_btn: val })
    }

    toggleleavetwo = (value, val) => () => {
        this.setState({ cancel_font: value, cancel_btn: val })
    }

    render() {

        const { t, i18n } = this.props;
        const enablecancelvote = this.props.short.enablecancelvote;
        const allcontest = this.props.allcontest;
        const buyvotes = allcontest == 1 ? this.props.singlepost.allcatoption.wpvc_category_buyvotes_settings == "on" : this.props.short.allcatoption.wpvc_category_buyvotes_settings == "on";

        if (!buyvotes && enablecancelvote == true && this.state.status === true) {
            const { cancel_button_font, cancel_button_color, cancel_button_color_hover, cancel_button_bgcolor, cancel_button_bgcolor_hover } = this.props.settings.color;
            if (allcontest == 1) {
                return (
                    (<Grid2 size={4}>
                        <IconButton color="secondary"
                            style={{ fontSize: cancel_button_font + 'px', 'color': this.state.cancel_font, 'background': this.state.cancel_btn }}
                            onClick={() => this.props.handlevote(this.props.singlepost.id, this.props.singlepost.term_id, this.props.settings.contest, this.props.indexpost, 1)}
                            onMouseOver={this.toggleHovertwo(cancel_button_color_hover, cancel_button_bgcolor_hover)}
                            onMouseLeave={this.toggleleavetwo(cancel_button_color, cancel_button_bgcolor)}>
                            <CancelIcon />
                        </IconButton>
                    </Grid2>)
                );
            }
            else {
                return (
                    <Button className={'wpvc_cancel_btn ' + this.props.view}
                        onClick={() => this.props.handlevote(this.props.singlepost.id, this.props.singlepost.term_id, this.props.settings.contest, this.props.indexpost, 1)}
                        style={{ fontSize: cancel_button_font + 'px', 'color': this.state.cancel_font, 'background': this.state.cancel_btn }}
                        onMouseOver={this.toggleHovertwo(cancel_button_color_hover, cancel_button_bgcolor_hover)}
                        onMouseLeave={this.toggleleavetwo(cancel_button_color, cancel_button_bgcolor)}
                        startIcon={<CancelIcon />} variant="contained">
                        {t('cancel_vote')}
                    </Button>
                )
            }
        }
        else {
            return "";
        }

    }
}

const settingstate = state => {
    return { post: state.wpvcfrontdata };
}

export default connect(settingstate, {})(withTranslation("translations")(CancelButton));